import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import useToastContext from 'hooks/useToastContext'
import { isEmpty } from 'lodash'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { AiFillEdit } from 'react-icons/ai'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import helper from '../../utils/helpers'

const ReasonReportList = ({
  reasonReportList,
  paginationObj,
  allReasonReport,
  handleEdit,
  handleView,
  sort,
  setSort,
  manager
}) => {
  const notification = useToastContext()
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.reasonReportStatus}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        allReasonReport()
      }
    } catch (error) {
      console.log('error in get all subcategory list==>>>>', error.message)
    }
  }

  return (
    <div>
      <div className='p-3'>
        <div className='overflow-x-auto relative 
 border'>
          <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
            <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
              <tr>
                <th scope='col' className='py-3 px-6 text-center'>
                  #
                </th>
                <th scope='col' className='py-3 px-6'>
                  Reason
                </th>
                <th scope='col' className='py-3 px-6'>
                  Reason {t('O_ARABIC')}
                </th>
                <th scope='col' className='py-3 px-6'>
                  <div className='flex justify-end'>
                    <span>{t('O_CREATED_AT')}</span>
                  </div>
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  <div className='flex justify-end'>
                    <span> Updated date</span>
                  </div>
                </th>

                {(manager?.add || user?.role === 'admin') && (
                  <>
                    <th scope='col' className='py-3 px-6 text-center'>
                      {t('O_STATUS')}
                    </th>
                    <th scope='col' className='py-3 px-6 text-center'>
                      {t('O_ACTION')}
                    </th>
                  </>
                )}
              </tr>
            </thead>

            <tbody>
              {reasonReportList &&
                reasonReportList.map((item, i) => {
                  return (
                    <tr
                      key={i}
                      className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                    >
                      <th
                        scope='row'
                        className='py-2 px-2 border-r text-center font-medium text-gray-900  dark:text-white'
                      >
                        {i + 1 + 10 * (paginationObj?.page - 1)}
                      </th>
                      <td className='py-2 px-2 border-r'>{item?.name}</td>
                      <td className='py-2 px-2 border-r'>{item?.nameAr}</td>
                      <td className='py-2 px-2 border-r text-right'>
                        {dayjs(item?.createdAt).format('DD-MM-YYYY h:mm A')}{' '}
                      </td>
                      <td className='py-2 px-2 border-r text-right'>
                        {dayjs(item?.updatedAt).format('DD-MM-YYYY h:mm A')}{' '}
                      </td>
                      {(manager?.add || user?.role === 'admin') && (
                        <td className='py-2 px-2 border-r text-center'>
                          <label
                            className='inline-flex relative items-center cursor-pointer'
                            title={`${
                              item?.status === 'active' ? 'Active' : 'Inactive'
                            }`}
                          >
                            <input
                              type='checkbox'
                              className='sr-only peer'
                              checked={item?.status === 'active'}
                              onChange={e =>
                                helper.alertFunction(
                                  `Are you sure want to ${
                                    e.target.checked ? 'active' : 'inactive'
                                  } ${item.name}?`,
                                  item,
                                  handelStatusChange
                                )
                              }
                            />
                            <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                          </label>
                        </td>
                      )}
                      {(manager?.add || user?.role === 'admin') && (
                        <td className='py-2 px-2 border-l'>
                          <div className=''>
                            <ul className='flex justify-center'>
                              <li
                                onClick={() => handleEdit(item)}
                                className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                              >
                                <button
                                  title='Edit'
                                  className='hover:text-blue-700 transition duration-150 ease-in-out'
                                  data-bs-toggle='tooltip'
                                >
                                  {' '}
                                  <AiFillEdit className='cursor-pointer w-5 h-5 text-slate-600' />
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      )}
                    </tr>
                  )
                })}
              {isEmpty(reasonReportList) && (
                <tr className='bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-2 px-2 border-r' colSpan={7}>
                    {t('O_NO_RECORD_FOUND')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ReasonReportList
